import React from "react";

import "../styles/globals.scss";
import "../styles/index.scss";

import type { AppProps } from "next/app";
import Head from "next/head";
import { AppProvider, useApp } from "components/app";

import { Content } from "components/layout";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>Log In - Blindspot Referrals</title>
        <meta name="description" content="Coming soon" />
        <link rel="icon" href="/favicon.ico" />
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&amp;family=Raleway:wght@300;400;500;600;700&amp;display=swap"
          rel="stylesheet"
        />
        <meta
          name="description"
          content="The Blindspot Referral Program enables anyone to earn money by referring clients to Blindspot. Clients receive free credits and you earn money once they create their first campaign."
        />
        <meta
          name="image"
          content="https://refferal.seeblindspot.com/images/logo-blindspot.svg"
        />
        <meta
          property="og:title"
          content="Blindspot Referral Program - The Easiest Way To Get On A Billboard"
        />
        <meta
          property="og:image"
          content="https://refferal.seeblindspot.com/images/logo-blindspot.svg"
        />
        <meta
          property="og:description"
          content="The Blindspot Referral Program enables anyone to earn money by referring clients to Blindspot. Clients receive free credits and you earn money once they create their first campaign."
        />
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://refferal.seeblindspot.com/"
        />
        <meta
          property="twitter:title"
          content="Blindspot Referral Program - The Easiest Way To Get On A Billboard"
        />
        <meta
          property="twitter:description"
          content="The Blindspot Referral Program enables anyone to earn money by referring clients to Blindspot. Clients receive free credits and you earn money once they create their first campaign."
        />
        <meta
          property="twitter:image"
          content="https://refferal.seeblindspot.com/images/logo-blindspot.svg"
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W2PGPSV');`,
          }}
        ></script>
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="//js.hs-scripts.com/9398621.js"
        ></script>
      </Head>
      <Content>
        <AppProvider>
          <Component {...pageProps} />
        </AppProvider>
      </Content>
    </>
  );
}

export default MyApp;
